import { Component, Type } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core'
import { SvgIconComponent } from 'angular-svg-icon'
import { differenceInCalendarDays } from 'date-fns'
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker'
import { NzSelectSizeType } from 'ng-zorro-antd/select'

import { FormlyFieldProps } from '../common.types'

interface DateRangeProps extends FormlyFieldProps {
  size?: NzSelectSizeType
}

export interface FormlyDateRangeFieldConfig
  extends FormlyFieldConfig<DateRangeProps> {
  type: 'date-range' | Type<DateRangeFieldTypeComponent>
}

@Component({
  selector: 'app-date-range-field-type',
  imports: [
    NzDatePickerModule,
    ReactiveFormsModule,
    FormlyModule,
    SvgIconComponent,
  ],
  templateUrl: './date-range-field-type.component.html',
})
export class DateRangeFieldTypeComponent extends FieldType<
  FieldTypeConfig<DateRangeProps>
> {
  public today = new Date()

  public disabledDate = (current: Date): boolean =>
    differenceInCalendarDays(current, this.today) > 0
}
